import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { servicesAtomReadOnly } from "./servicesAtom";

export const serviceAtomFamily = atomFamily((appId: string) => {
  const serviceAtom = atom((get) => {
    // Need this or else when you clear the app, the previous service will be returned
    if (!appId) return undefined;

    const services = get(servicesAtomReadOnly);

    return services.find((service) => {
      return service.selected_api.includes(`${appId.split("@")[0]}`);
    });
  });

  serviceAtom.debugLabel = `serviceAtomFamily(${appId})`;
  return serviceAtom;
});
